import { getData } from '../../../_helpers/getData';
import React, { useEffect, useState, useRef } from "react";
import CustomModal from "../../ReactModal";
import Persona from "persona";

import { AiOutlinePlus } from "react-icons/ai";
import { FaCheckCircle } from "react-icons/fa";
import { BsPlusCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { userService, bankService } from "../../../_services";
import constant from "../../../_config/constant";
import { OTPInput } from "./OTPInput";
import { OTP_LENGTH } from "../../../_helpers/otp";
import { AddBankAccountForm } from "./AddBankAccountForm";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { AppConfig } from "../../../Config";
var Modal = require("react-bootstrap-modal");

export const SecurityCheckPoints = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  requesting,
  hostDetail,
  setDetail,
  saveAsDraft,
  draftRequesting,
  isPaymentConfirm,
  verification,
  writesBlocked = false
}) => {
  const [bankAccountModal, setBankAccountModal] = useState(false);
  const [payoutModal, setPayoutModal] = useState(false);
  const [selfieModal, setSelfieModal] = useState(false);
  const [verifyPersonalEmailModal, setVerifyPersonalEmailModal] = useState(
    false
  );
  const [verifyPhoneModal, setVerifyPhoneModal] = useState(false);
  const [verifyPayoutMethod, setVerifyPayoutMethod] = useState(false);

  const [phoneVerificationRequest, setphoneVerificationRequest] = useState(
    false
  );
  const [emailVerificationRequest, setEmailVerificationRequest] = useState(
    false
  );
  const userId = getData().id;

  const phoneOtpRef = useRef();
  const emailOtpRef = useRef();

  const [accountForm, setAccountForm] = useState({});
  const [bankAdding, SetBankAdding] = useState(false);
  const history = useHistory();

  const setValue = (tag, value) => {
    setAccountForm({ ...accountForm, [tag]: value });
  };

  const togglePayout = () => {
    setPayoutModal(!payoutModal);
  };

  const toggleSelfieModal = () => {
    setSelfieModal(!selfieModal);
  };

  const togglePhoneModal = () => {
    setVerifyPhoneModal(!verifyPhoneModal);
  };

  const togglePersonalEmailModal = () => {
    setVerifyPersonalEmailModal(!verifyPersonalEmailModal);
  };

  const toggleVerifyPayoutMethod = () => {
    setVerifyPayoutMethod((e) => !e);
  };

  const goOverSerringPage = () => {
    saveAsDraft({ onComplete: () => history.push("/setting/payout-method") });
  };
  const toggleBankAccountModal = goOverSerringPage;

  const resendPhoneOtp = async () => {
    try {
      const res = await userService.sendVerifyPhoneOtp();
      if (res.status) {
        toast.success("OTP sent successfully!");
      } else toast.error(res.message);
    } catch {
      toast.error("Something went wrong!");
    }
  };

  const resendEmailOtp = async () => {
    try {
      const res = await userService.sendVerifyEmailOtp();
      if (res.status) {
        toast.success("OTP sent successfully!");
      } else toast.error(res.message);
    } catch {
      toast.error("Something went wrong!");
    }
  };

  const verifyPhoneOtp = async (otp) => {
    try {
      setphoneVerificationRequest(true);
      const res = await userService.verifyPhone({ otp });

      setphoneVerificationRequest(false);
      if (res.status) {
        hostDetail.phoneVerification = 1;
        setDetail({ ...hostDetail });
        setVerifyPhoneModal(false);
        await verification.refresh();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
      setphoneVerificationRequest(false);
    }
  };

  const verifyEmailOtp = async (otp) => {
    try {
      setEmailVerificationRequest(true);
      const res = await userService.verifyEmail({ otp });

      setEmailVerificationRequest(false);
      if (res.status) {
        hostDetail.personalEmailVerification = 1;
        setDetail({ ...hostDetail });
        setVerifyPersonalEmailModal(false);
        await verification.refresh();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Something went wrong!");
      setEmailVerificationRequest(false);
    }
  };

  // /user/updateIdVerificationStatus does not exist on the API - every call to it 404s,
  // and this had no .catch, so nothing ever ran after Persona's inquiry completed. This
  // is also why "Review & Publish" never appeared once this checkpoint was enabled -
  // idVerificationStatus could never flip to 1, and that gates the button further down.
  // Identity verification is only ever confirmed by Persona's own signed webhook,
  // asynchronously - a client cannot self-report "I'm verified," and mutating
  // hostDetail.idVerificationStatus locally would be a guess, not a fact. Refetch the
  // real host record instead so the checkpoint reflects the actual server state.
  const updateIdVerificationStatus = async () => {
    toast.info('Verification submitted. This can take a few minutes to be confirmed.');
    await verification.refresh();
  };

  const saveBankAccount = (accountForm) => {
    if (accountForm.accountNumber != accountForm.confirmAccountNumber) {
      toast.info("Account number and confirm account number must be same.");
      return;
    }
    SetBankAdding(true);
    var postObj = { hostId: hostDetail.id, ...accountForm };
    bankService.addBank(postObj).then(
      (objS) => {
        if (objS.status) {
          toast.success("Bank account added successfully");
          verification.refresh();
          setAccountForm({});
        } else {
          toast.error(objS.message);
        }
        toggleBankAccountModal();
        SetBankAdding(false);
        verification.refresh();
      },
      (error) => {
        toggleBankAccountModal();
        SetBankAdding(false);
      }
    );
  };


  return (
    <div className={className}>
      <div className=" ">
        <h4 className="mb-5 tw-flex tw-justify-start tw-items-center">
          <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
          {
              hostDetail.payoutVerification == 1 
              ?  11 : 12 }
          </span>{" "}
          Security Checkpoint
        </h4>
        <div className="row">
          {hostDetail ? (
            <div>
              <div className="tw-flex tw-mb-4 tw-justify-between tw-items-center">
                <h5>
                  1. Email
                  {verification.emailVerified
                    ? " Verified "
                    : " Not Verified "}
                  {verification.emailVerified ? (
                    <FaCheckCircle className="tw-text-green-500" size={24} />
                  ) : (
                    <BsPlusCircleFill
                      className="tw-transform tw-rotate-45 tw-text-red-500"
                      size={26}
                    />
                  )}
                </h5>
                {!verification.emailVerified && (
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      resendEmailOtp();
                      togglePersonalEmailModal();
                    }}
                  >
                    Verify
                  </button>
                )}
              </div>
              <div className="tw-flex tw-mb-4 tw-justify-between tw-items-center">
                <h5>
                  2. Phone
                  {verification.phoneVerified
                    ? " Verified "
                    : " Not Verified "}
                  {verification.phoneVerified ? (
                    <FaCheckCircle className="tw-text-green-500" size={24} />
                  ) : (
                    <BsPlusCircleFill
                      className="tw-transform tw-rotate-45 tw-text-red-500"
                      size={26}
                    />
                  )}
                </h5>
                {!verification.phoneVerified && (
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      resendPhoneOtp();
                      togglePhoneModal();
                    }}
                  >
                    Verify
                  </button>
                )}
              </div>
              {
                AppConfig.ENABLE_SELFIE_AND_ID_VERIFICATION_CHECKPOINT &&  <div className="tw-flex tw-mb-4 tw-justify-between tw-items-center">
                <h5>
                  3. Selfie & ID
                  {verification.identityVerified
                    ? " Verified "
                    : " Not Verified "}
                  {verification.identityVerified ? (
                    <FaCheckCircle className="tw-text-green-500" size={24} />
                  ) : (
                    <BsPlusCircleFill
                      className="tw-transform tw-rotate-45 tw-text-red-500"
                      size={26}
                    />
                  )}
                </h5>
                {!verification.identityVerified && (
                  <button
                    className="btn btn-secondary"
                    onClick={toggleSelfieModal}
                  >
                    Selfie & Id Verification
                  </button>
                )}
              </div>
              }
             
              <div className="tw-flex tw-mb-4 tw-justify-between tw-items-center">
                <h5>
                {AppConfig.ENABLE_SELFIE_AND_ID_VERIFICATION_CHECKPOINT? '4.':'3.'} Payment Information
                  {verification.paymentReady
                    ? " Added "
                    : verification.loading ? " Checking… " : " Not confirmed "}
                  {verification.paymentReady ? (
                    <FaCheckCircle className="tw-text-green-500" size={24} />
                  ) : (
                    <BsPlusCircleFill
                      className="tw-transform tw-rotate-45 tw-text-red-500"
                      size={26}
                    />
                  )}
                </h5>
                {!verification.paymentReady && !verification.loading && (
                  <button
                    className="btn btn-secondary"
                    data-bs-toggle="modal"
                    // onClick={toggleBankAccountModal}
                    onClick={goOverSerringPage}
                    disabled={writesBlocked || requesting || draftRequesting}
                  >
                    Check payout setup
                  </button>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>

        {verifyPersonalEmailModal && (
          <CustomModal>
            <div className="tw-w-[85%] tw-mx-auto ">
              <span
                onClick={togglePersonalEmailModal}
                className="tw-rounded-full tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-bg-white tw-p-2 tw-block tw-ml-auto tw-text-gray-700 tw-h-12 tw-w-12"
              >
                <AiOutlinePlus
                  size={22}
                  className="tw-transform tw-rotate-45"
                />
              </span>
            </div>
            <div className="tw-bg-white tw-w-[75%] tw-mx-auto tw-p-10 tw-rounded-3xl tw-border-2 ">
              <h3 className="tw-text-lg tw-text-center tw-font-medium tw-text-gray-700">
                Enter OTP
              </h3>
              <p className="tw-text-gray-700 tw-text-center tw-text-sm">
                Enter the OTP received on your Email
              </p>
              <OTPInput ref={emailOtpRef} />
              <div className="tw-text-sm tw-text-center">
                <button
                  onClick={() => {
                    verifyEmailOtp(emailOtpRef.current.value);
                  }}
                  disabled={emailVerificationRequest}
                  className="tw-w-max tw-text-center tw-mx-auto tw-col-span-full tw-text-sm tw-mx-auto tw-p-2 tw-px-4 tw-rounded tw-bg-primary tw-border-0 tw-text-white "
                >
                  {emailVerificationRequest ? "Verfing.." : "Verify"}
                </button>
              </div>
              <p
                onClick={resendEmailOtp}
                className="tw-text-sm tw-text-center tw-my-2 tw-text-primary tw-cursor-pointer"
              >
                Resend OTP
              </p>
            </div>
          </CustomModal>
        )}

        {verifyPhoneModal && (
          <CustomModal>
            <div className="tw-w-[85%] tw-mx-auto ">
              <span
                onClick={togglePhoneModal}
                className="tw-rounded-full tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-bg-white tw-p-2 tw-block tw-ml-auto tw-text-gray-700 tw-h-12 tw-w-12"
              >
                <AiOutlinePlus
                  size={22}
                  className="tw-transform tw-rotate-45"
                />
              </span>
            </div>
            <div className="tw-bg-white tw-w-[75%] tw-mx-auto tw-p-10 tw-rounded-3xl tw-border-2 ">
              <h3 className="tw-text-lg tw-text-center tw-font-medium tw-text-gray-700">
                Enter OTP
              </h3>
              <p className="tw-text-gray-700 tw-text-center tw-text-sm">
                Enter the OTP received on your mobile number
              </p>
              <OTPInput ref={phoneOtpRef} length={OTP_LENGTH.phone} />
              <div className="tw-text-sm tw-text-center">
                <button
                  onClick={() => {
                    verifyPhoneOtp(phoneOtpRef.current.value);
                  }}
                  disabled={phoneVerificationRequest}
                  className="tw-w-max tw-text-center tw-mx-auto tw-col-span-full tw-text-sm tw-mx-auto tw-p-2 tw-px-4 tw-rounded tw-bg-primary tw-border-0 tw-text-white "
                >
                  {phoneVerificationRequest ? "Verfing.." : "Verify"}
                </button>
              </div>
              <p
                onClick={resendPhoneOtp}
                className="tw-text-sm tw-text-center tw-my-2 tw-text-primary tw-cursor-pointer"
              >
                Resend OTP
              </p>
            </div>
          </CustomModal>
        )}

        {selfieModal && (
          <CustomModal>
            <div className="tw-w-[85%] tw-mx-auto ">
              <span
                onClick={toggleSelfieModal}
                className="tw-rounded-full tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-bg-white tw-p-2 tw-ml-auto tw-text-gray-700 tw-h-12 tw-w-12"
              >
                <AiOutlinePlus
                  size={22}
                  className="tw-transform tw-rotate-45"
                />
              </span>
            </div>
            <div className="tw-bg-white tw-w-[75%] tw-mx-auto tw-p-10 tw-rounded-3xl tw-border-2 ">
              <Persona.Inquiry
                referenceId={userId}
                templateId={constant.persona_template_id}
                environment={constant.persona_mode}
                onLoad={() => {}}
                onComplete={({ inquiryId, status, fields }) => {
                  // Inquiry completed. Optionally tell your server about it.

                  if (status === "completed") {
                    updateIdVerificationStatus();
                    toggleSelfieModal();
                  }
                }}
              />
            </div>
          </CustomModal>
        )}

        {bankAccountModal && (
          <CustomModal>
            <AddBankAccountForm
              toggleBankAccountModal={toggleBankAccountModal}
              saveBankAccount={saveBankAccount}
              bankAdding={bankAdding}
            />
            {/* <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Your Bank Account</h5>
                <button
                  type="button"
                  className="tw-bg-transparent tw-border-0"
                  onClick={toggleBankAccountModal}
                >
                  <span className="tw-cursor-pointer">
                    <AiOutlinePlus
                      size={24}
                      className="tw-transform tw-rotate-45"
                    />
                  </span>
                </button>
              </div>
              <form onSubmit={saveBankAccount}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Currency
                        </label>
                        <select
                          name="currency"
                          className="form-control wide"
                          onChange={(e) => setValue("currency", e.target.value)}
                          value={accountForm["currency"]}
                          required
                        >
                          <option value="">Select</option>
                          <option value="usd">USD</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">Country</label>
                        <select
                          name="country"
                          className="form-control wide"
                          onChange={(e) => setValue("country", e.target.value)}
                          value={accountForm["country"]}
                          required
                        >
                          <option value="">Select</option>
                          <option value="US">USA</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Account Holder Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Account Holder Name"
                          required
                          name="accountHolderType"
                          onChange={(e) =>
                            setValue("accountHolderName", e.target.value)
                          }
                          value={accountForm["accountHolderName"]}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Account Holder Type
                        </label>
                        <select
                          className="form-control wide"
                          required
                          name="accountHolderType"
                          onChange={(e) =>
                            setValue("accountHolderType", e.target.value)
                          }
                          value={accountForm["accountHolderType"]}
                        >
                          <option value="">Select</option>
                          <option value="individual">Individual</option>
                          <option value="company">Company</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Routing Number
                        </label>
                        <input
                          type="text"
                          name="routingNumber"
                          className="form-control"
                          placeholder="Routing Number"
                          required
                          onChange={(e) =>
                            setValue("routingNumber", e.target.value)
                          }
                          value={accountForm["routingNumber"]}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Account Number
                        </label>
                        <input
                          type="text"
                          name="accountNumber"
                          className="form-control"
                          placeholder="Account Number"
                          required
                          onChange={(e) =>
                            setValue("accountNumber", e.target.value)
                          }
                          value={accountForm["accountNumber"]}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 mb-2">
                      <div className="mb-3">
                        <label className="text-label form-label">
                          Confirm Account Number
                        </label>
                        <input
                          type="text"
                          name="confirmAccountNumber"
                          className="form-control"
                          placeholder="Confirm Account Number"
                          required
                          onChange={(e) =>
                            setValue("confirmAccountNumber", e.target.value)
                          }
                          value={accountForm["confirmAccountNumber"]}
                        />
                      </div>
                    </div>
                    <button
                      disabled={bankAdding}
                      type="submit"
                      className="btn btn-secondary mb-3"
                    >
                      {bankAdding ? "Please wait ..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div> */}
          </CustomModal>
        )}
      </div>
        <div aria-live="polite" className="mx-2 mb-3">
          {verification.blockers.map(message => <p className="text-dark" key={message}>{message}</p>)}
          {!verification.ready && (
            <button type="button" className="btn btn-secondary" onClick={verification.refresh}
              disabled={verification.loading || requesting || draftRequesting}>
              {verification.loading ? "Checking…" : "Retry checks"}
            </button>
          )}
        </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2  tw-mb-2"
        >
          Prev
        </button>

        <button
          onClick={() => { if (verification.canSubmit()) onNext(); }}
          type="button" className="btn btn-secondary mx-2 tw-mb-2"
          disabled={writesBlocked || !verification.ready || requesting || draftRequesting}
        >
          {requesting ? "Adding ..." : "Review & Publish"}
        </button>

        <button
          type="button"
          disabled={writesBlocked || draftRequesting}
          onClick={saveAsDraft}
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          {draftRequesting ? "Adding ..." : "Save as Draft"}
        </button>
      </div>
    </div>
  );
};
